var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoveit = function SvgLoveit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#040512",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.998 9.06a3.4 3.4 0 0 0-1.11-.784 3.26 3.26 0 0 0-2.619 0 3.4 3.4 0 0 0-1.11.785l-.66.698-.658-.698A3.33 3.33 0 0 0 7.42 8c-.907 0-1.777.38-2.419 1.06A3.73 3.73 0 0 0 4 11.62c0 .96.36 1.882 1.002 2.56l.66.698L10.5 20l4.838-5.12.66-.698c.317-.337.57-.736.742-1.175a3.8 3.8 0 0 0 0-2.771 3.6 3.6 0 0 0-.742-1.175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F3A1C2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.537 3.442a1.6 1.6 0 0 0-.512-.327 1.64 1.64 0 0 0-1.209 0 1.6 1.6 0 0 0-.512.327l-.304.29-.304-.29A1.62 1.62 0 0 0 17.579 3c-.419 0-.82.16-1.117.442A1.48 1.48 0 0 0 16 4.509c0 .4.166.784.462 1.067l.305.29L19 8l2.233-2.134.304-.29c.147-.14.263-.307.343-.49a1.45 1.45 0 0 0-.343-1.644"
  })));
};
export default SvgLoveit;